import { toIntlLocale } from "@/i18n/to-intl-locale";

export function monthNumberToName(
  monthNumber: number,
  locale: string,
  options: Intl.DateTimeFormatOptions = { month: "long" },
): string {
  if (monthNumber < 1 || monthNumber > 12) {
    throw new Error(
      `Invalid month number: ${monthNumber}. Month number must be between 1 and 12.`,
    );
  }
  const date = new Date(2000, monthNumber - 1, 1);
  return new Intl.DateTimeFormat(toIntlLocale(locale), options).format(date);
}
